import { createSelector } from 'reselect';
import { taskSelectors } from '../../task';

const getInitialValues = taskId =>
  createSelector([taskSelectors.getById], taskById => (taskId !== -1 ? taskById[taskId] : { TaskId: -1 }));

export const makeGetInitialValues = createSelector(getInitialValues, initialValues => initialValues);
